// extracted by mini-css-extract-plugin
export default {"pageWrapper":"RecipeFormScreen_pageWrapper__J7c7d","loading":"RecipeFormScreen_loading__zuU+0"};